import styled from "@emotion/styled";
import React from "react";
import Button from "@components/Button";
import { useLang } from "@src/hooks/useLang";
import { observer } from "mobx-react-lite";
import { useDevicesScreenVM } from "@screens/DevicesScreen/DevicesScreenVM";

const Root = styled(Button)`
  width: fit-content;
  white-space: nowrap;
`;

/**
 * Sits beside "New device" (CreateDeviceButton). The screen renders it only
 * for users with the `john_deere_combines` config and a live John Deere
 * connection.
 */
const ImportFromJohnDeereButton: React.FC = () => {
  const lang = useLang();
  const vm = useDevicesScreenVM();
  return (
    <Root kind="outline" onClick={() => vm.setImportJohnDeereOpened(true)}>
      {lang.devices.importJohnDeereButton}
    </Root>
  );
};
export default observer(ImportFromJohnDeereButton);
